import * as actionTypes from './actionTypes';

export const enableAndDisableDeviceSteering = (method, deviceMac) => ({
    type: actionTypes.DEVICE_STEERING_PUT_DELETE,
    method,
    deviceMac
});

export const startSteering = ({ deviceMac, routerMac }) => ({
    type: actionTypes.START_DEVICE_STEERING_POLLING,
    deviceMac,
    routerMac
})

export const setSteeringInitiatedAt = ({ timestamp }) => ({
    type: actionTypes.DEVICE_STEERING_START_TIME,
    timestamp
})

export const setSteeringExpiresAt = ({ timestamp }) => ({
    type: actionTypes.SET_STEERING_EXPIRES_AT,
    timestamp,
})

export const endSteeringPolling = () => ({
    type: actionTypes.STOP_DEVICE_STEERING_POLLING,
})

export const stopSteering = ({ deviceMac, routerMac }) => ({
    type: actionTypes.STOP_DEVICE_STEERING,
    deviceMac,
    routerMac
})

export const enableAndDisableDeviceSteeringSuccess = () => ({
    type: actionTypes.DEVICE_STEERING_PUT_DELETE_SUCCESS
});

export const enableAndDisableDeviceSteeringFailed = ({ error }) => ({
    type: actionTypes.DEVICE_STEERING_PUT_DELETE_FAILED,
    error
});

export const getDeviceSteering = (deviceMac) => ({
    type: actionTypes.GET_DEVICE_STEERING,
    deviceMac
});

export const getDeviceSteeringSuccess = (payload) => ({
    type: actionTypes.GET_DEVICE_STEERING_SUCCESS,
    payload
});

export const getDeviceSteeringFailed = () => ({
    type: actionTypes.GET_DEVICE_STEERING_FAILED
});

export const resetDevicesSteeringErrorSuccess = () => ({
    type: actionTypes.RESET_DEVICES_STEERING_ERROR_SUCCESS
});

export const startSteeringAll = (selectedEquipment) => ({
    type: actionTypes.START_DEVICE_STERING_ALL_POLLING,
    selectedEquipment
});

export const startSteeringAllSuccess = () => ({
    type: actionTypes.START_DEVICE_STERING_ALL_POLLING_SUCCESS
});

export const startSteeringAllFailed = () => ({
    type: actionTypes.START_DEVICE_STERING_ALL_POLLING_FAILED
});